import Chip from "@material-ui/core/Chip"

import deepOrange from "@material-ui/core/colors/deepOrange"
import purple from "@material-ui/core/colors/purple"
import blue from "@material-ui/core/colors/blue"
import green from "@material-ui/core/colors/green"

import { Role } from "common/types/user.type"

export const roleColor = {
    [Role[Role.Admin]]: {
        backgroundColor: deepOrange[300],
        color: deepOrange[900]
    },
    [Role[Role.Superadmin]]: {
        backgroundColor: purple[300],
        color: purple[900]
    },
    [Role[Role.Moderator]]: {
        backgroundColor: blue[300],
        color: blue[900]
    },
    [Role[Role.User]]: {
        backgroundColor: green[300],
        color: green[900]
    }
}

const UserRoleChip = ({ role }) => {
    return <Chip size="small" label={role} style={{ ...roleColor[role] }} />
}

export default UserRoleChip
